import type { FaireProductEntity } from "../../entity_types/product";

export const p_r65bhpumum: FaireProductEntity = {
  token: "p_r65bhpumum",
  type: "product",
  name: "Beer Bacon Maple BBQ Sauce & Marinade Net 15.6oz",
  brandToken: "b_zr87no4yn6",
  brandName: "Elijah's Xtreme Gourmet Sauces",
  imageUrl:
    "https://cdn.faire.com/fastly/d2142a97ffe7f5f6624980b45ff34c1d769743e42a444a7f5768d1368ce40411.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f473fb5ddb1b70c16bc05c1b05dcb7fbd61508216676e0322d8d7df164c114f5.png",
    "https://cdn.faire.com/fastly/3d39dfe0387f828a20dfef2047088a9990fe76c4b1ca5bc91a3ae51b820b4c30.png",
    "https://cdn.faire.com/fastly/41a74c448ec65d043501c11b5692c43c1907a6784765f1199716ebc5ce0e2e23.webp",
    "https://cdn.faire.com/fastly/975847ef63e9b8abe7f15e9ff7cb6bc6239d7761894f974aae768f6ca889d80f.png",
    "https://cdn.faire.com/fastly/b1b3a88bd8d858f400c9075bc28d3009952c057f46c7dea3a9e3b401a8761d00.png",
  ],
  priceDollars: 6.6,
  description:
    "The most uniquely delicious sauce we've ever made! Bold, tangy and bursting with flavor. Tomato base, mildly spicy, marinade & dipping sauce.\n\nBeer Bacon Maple BBQ Sauce & Marinade\n\nThe most uniquely delicious sauce we've ever made – hands down. This bold, tangy, and irresistibly rich BBQ sauce is a flavor explosion built for food lovers who don't play it safe. With a savory tomato base, a touch of mild heat, and a one-of-a-kind sweet-and-smoky twist, it’s your new go-to for turning everyday eats into unforgettable bites.\n\nCrafted with real beer, rich maple syrup, and vegetarian-friendly bacon flavoring (yep, bacon without the oink), this mouthwatering BBQ sauce pulls double duty as both a dipping sauce and a marinade. It brings serious attitude and a bold kick to whatever it touches.\n\nPerfect for:\nChicken, pulled pork, burgers, brats, French fries, tofu, grilled veggies – if it’s edible, it’s fair game.\n\nWhat’s NOT inside:\n❌ No high-fructose corn syrup\n✅ 100% crave-approved flavor",
  tags: [],
  msrpDollars: 10.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:06.886Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
